import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useModal } from '../../components/layout';

import RAGForm from '../../components/rag/RAGForm';
import KnowledgeBaseSelectionModal from '../../components/modals/rag/KnowledgeBaseSelectionModal';
import { API_ENDPOINTS } from '../../config/api.config';
import { apiService } from '../../services/apiService';
import type {KnowledgeBase, RAGFormData} from "../../types/knowledge-base";
import ContentSkeleton from "@/components/loading/ContentSkeleton.tsx";

interface IndexesListResponse {
  data: {
    indexes: KnowledgeBase[];
  }
}

const Create: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { user } = useAuth();
  const modalState = useModal();
  const [showKnowledgeBaseModal, setShowKnowledgeBaseModal] = useState(false)


  const [formData, setFormData] = useState<RAGFormData>({
    name: '',
    description: '',
    llmModel: 'gpt-3.5-turbo',
    indexIds: [],
    selectedKnowledgeBases: [],
    integrations: []
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    modalState.setIsLoading(true);
    modalState.setError(null);

    try {
      await apiService.post(API_ENDPOINTS.RAG.BASE, formData);
      navigate(`/rag-applications`);
    } catch (err) {
      console.error('Error creating application:', err);
      modalState.setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      modalState.setIsLoading(false);
    }
  };

  const handleChange = (field: keyof RAGFormData, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleKnowledgeBaseSelect = async (selectedIds: string[]) => {
    try {
      const response = await apiService.get<IndexesListResponse>(
          `${API_ENDPOINTS.INDEXES.LIST}?ids=${selectedIds.join(',')}`
      );

      handleChange('indexIds', selectedIds);
      handleChange('selectedKnowledgeBases', response.data.indexes || []);
    } catch (error) {
      console.error('Error fetching knowledge base details:', error);
      modalState.setError('Failed to fetch knowledge base details');
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 100);
    return () => clearTimeout(timer);
  }, []);

  if (!user) return null;

  return (
      <>
        <div className="page-container">
          <div className="content-header">
            <h5 className="mb-4">New RAG Application</h5>
            {isLoading ? (
                <ContentSkeleton />
            ) : (
            <RAGForm
                formData={formData}
                onSubmit={handleSubmit}
                onChange={handleChange}
                error={modalState.error}
                isLoading={modalState.isLoading}
                mode="create"
                onDelete={() => {}}
            />
                )}
          </div>
        </div>

        <KnowledgeBaseSelectionModal
            isOpen={showKnowledgeBaseModal}
            onClose={() => setShowKnowledgeBaseModal(false)}
            onSelect={handleKnowledgeBaseSelect}
            selectedKnowledgeBases={formData.indexIds}
        />
      </>
  );
};

export default Create;